import { createSelector } from '@ngrx/store';
import * as Adapters from '../../adapters';
import { getOverviewEntities, getSharedEntities } from './common.selectors';

export const getTracker = createSelector(
  getOverviewEntities,
  getSharedEntities,
  (overviewEntities) =>
    Adapters.getTracker(
      overviewEntities['status-tracker-content']?.statusTrackerContent,
      overviewEntities['future-activity-content']?.futureActivityContent,
      overviewEntities['aem-summary-content']?.aemSummaryContent?.tracker,
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.overview
        .tracker,
      [
        overviewEntities['status-tracker-content-error']
          ?.statusTrackerContentError,
        overviewEntities['future-activity-content-error']
          ?.futureActivityContentError
      ],
      overviewEntities['aem-error-messages']?.aemErrorMessages
    )
);

export const getTrackerContent = createSelector(
  getOverviewEntities,
  (entities) => entities['status-tracker-content']?.statusTrackerContent
);

export const getFutureActivityRequest = createSelector(
  getOverviewEntities,
  (overviewEntities) =>
    Adapters.getFutureActivityRequest(
      overviewEntities['status-tracker-content']?.statusTrackerContent,
      overviewEntities['aem-content']?.aemContent?.requestProperty.carrierCode
    )
);

export const getSummary = createSelector(
  getSharedEntities,
  getOverviewEntities,
  (sharedEntities, overviewEntities) =>
    Adapters.getSummary(
      overviewEntities['aem-summary-content']?.aemSummaryContent?.summary,
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.overview
        .summary,
      sharedEntities['user-session']?.userSession?.smBalance // @TODO: nisha update this
    )
);
export const getStatus = createSelector(
  getSharedEntities,
  getOverviewEntities,
  (sharedEntities, overviewEntities) =>
    Adapters.getStatus(
      overviewEntities['aem-summary-content']?.aemSummaryContent?.status,
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.overview
        .status,
      sharedEntities['user-session']?.userSession?.millionMilerTier,
      overviewEntities['status-tracker-content']?.statusTrackerContent,
      [
        overviewEntities['status-tracker-content-error']
          ?.statusTrackerContentError
      ],
      overviewEntities['aem-error-messages']?.aemErrorMessages
    )
);

export const getCards = createSelector(
  getSharedEntities,
  getOverviewEntities,
  (sharedEntities, overviewEntities) =>
    Adapters.getCardBanner(
      overviewEntities['aem-summary-content']?.aemSummaryContent,
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.overview
        .cardBanner,
      sharedEntities['user-session']?.userSession?.cobrandCardtypeList || '',
      []
    )
);

export const getEarnsSummary = createSelector(
  getOverviewEntities,
  getSharedEntities,
  (overviewEntities, sharedEntities) =>
    Adapters.getEarnsSummary(
      overviewEntities['aem-summary-content']?.aemSummaryContent?.mqdSummary,
      overviewEntities['earns-summary-content']?.earnsSummaryData,
      sharedEntities['user-session']?.userSession?.countryCode,
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags
        .earnsSummary,
      [overviewEntities['earns-summary-content-error']?.earnsSummaryDataError],
      overviewEntities['aem-error-messages']?.aemErrorMessages
    )
);

export const getSkyClubTracker = createSelector(
  getSharedEntities,
  getOverviewEntities,
  (sharedEntities, overviewEntities) =>
    Adapters.getSkyClubTracker(
      overviewEntities['aem-summary-content']?.aemSummaryContent?.skyclub,
      overviewEntities['skyclub-tracker-content']?.skyclubTrackerData,
      sharedEntities['user-session']?.userSession,
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.skyclub,
      [
        overviewEntities['skyclub-tracker-content-error']
          ?.skyclubTrackerDataError
      ],
      overviewEntities['aem-error-messages']?.aemErrorMessages
    )
);
